import { render } from "./FormAddOnProductItem.vue?vue&type=template&id=3140ee9d&scoped=true"
import script from "./FormAddOnProductItem.vue?vue&type=script&lang=js"
export * from "./FormAddOnProductItem.vue?vue&type=script&lang=js"

import "./FormAddOnProductItem.vue?vue&type=style&index=0&id=3140ee9d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3140ee9d"]])

export default __exports__